/**
 * OnboardingGate — soft gate (pass-through).
 *
 * Story Onboarding-1 originally redirected users with completeness_pct < 100
 * to /onboarding. UX feedback (Story Onboarding-3) was that hard-gating new
 * users behind a long form before they ever see the platform hurts activation.
 *
 * Replacement strategy:
 *  - This component is now a pass-through. Kept as a stable wrapper so feature
 *    flag wiring + the import surface in App.tsx don't churn.
 *  - The completeness banner (`OnboardingNudge`) renders inside AppLayout to
 *    drive users back to /onboarding without blocking navigation.
 *  - AI-output features that depend on business context call
 *    `useOnboardingGuard()` to soft-block the action and surface a CTA.
 *
 * Spec: docs/stories/story-onboarding-1-foundation.md (amended in Story-3)
 */

import type { ReactNode } from "react";

export interface OnboardingGateProps {
  children: ReactNode;
}

export function OnboardingGate({ children }: OnboardingGateProps) {
  return <>{children}</>;
}
